"use client";

import { ADUserAvatar } from "@shared-components/ad-user-avatar";
import { Button } from "@shared-components/shadcn/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@shared-components/shadcn/dropdown-menu";
import { LogOut } from "lucide-react";
import { signOut, useSession } from "next-auth/react";
import { useLocalStorage } from "@shared-utils/hooks/use-local-storage";
import { EXPLICIT_LOGOUT_STORAGE_KEY } from "@shared-utils/constants";

export const UserDropdown = () => {
  const { data: session } = useSession();
  const [, setIsExplicitlyLoggedOut] = useLocalStorage(
    EXPLICIT_LOGOUT_STORAGE_KEY,
    false,
  );

  const handleSignOut = () => {
    setIsExplicitlyLoggedOut(true);
    void signOut();
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative mx-2 h-8 w-8 rounded-full">
          <ADUserAvatar
            imagePath={session?.user?.image as string}
            userPrincipalName={session?.user?.email as string}
            size={"small"}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="pb-0 text-sm font-bold">
          {"Logged in"}
        </DropdownMenuLabel>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">
              {session?.user?.name}
            </p>
            <p className="text-xs leading-none text-muted-foreground">
              {session?.user?.email}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleSignOut}>
          <LogOut className="mr-2 h-4 w-4" />
          <span>{"Log out"}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
